<script>
import { onMount } from "svelte";
import { StripeComponent } from "../../libraries/stripe/StripeComponent";
import { turpial } from "../../libraries/turpial";

export let stripe_key = null;
export let onMountCard = () => {};

/**
 * Estilos CSS para el contenedor
 */
export let style_border = "";
export let style_background = "";
export let style_border_radius = "";
export let style_box_shadow = "";

export let styles_input = { none: "none" };

let stripe;
let elements;
let id = "stripe-component-"+turpial.random_string(6);
let mounted = "";
let cardElement
let cardErrorElement

let stripeObjElements = {}
stripeObjElements.module = {}

/**
 * Variable global para 3PodWidgets
 */
window.tripod_register = window.tripod_register ?? {};
window.tripod_register.stripe = {};
window.tripod_register.stripe.module = {};
window.tripod_register.stripe.card = null;

onMount(()=>{
    StripeComponent(()=>{
        if(mounted === "mounted"){ return; }
        stripeObjElements.module = Stripe(stripe_key);
        window.tripod_register.stripe.module = stripeObjElements?.module;
        elements = stripeObjElements.module.elements();

        let container = document.querySelector(`#${id}`);
        cardElement = container.querySelector(".card-element");
        cardErrorElement = container.querySelector(".card-element-error");

        let style = {
            base: {
                color: '#32325d',
                fontFamily: '"Montserrat", Helvetica Neue", Helvetica, sans-serif',
                styles_input
            },
            invalid: {
                color: '#000ff',
                iconColor: '#fa755a'
            }
        };
        
        let card = elements.create("card", { style: style });
        stripeObjElements.card = card;
        window.tripod_register.stripe.card = stripeObjElements?.card;

        card.mount(cardElement);
        mounted = "mounted";
        
        stripeObjElements.cardErrorElement = cardErrorElement;
        window.tripod_register.stripe.cardErrorElement = cardErrorElement;

        onMountCard(stripeObjElements?.module, stripeObjElements?.card);

        card.on('change', ({error}) => {
            onMountCard(stripeObjElements?.module, stripeObjElements?.card, error);
            if (error) {
                cardErrorElement.textContent = error.message;
            } else {
                cardErrorElement.textContent = '';
            }
        });
    })

})


</script>

<div class="StripeComponent" id="{id}" style="{style_border} {style_background} {style_border_radius} {style_box_shadow}">
    <div class="card-element {mounted}">
        <!-- Elements will create input elements here -->
    </div>
    <!-- We'll put the error messages in this element -->
    <div class="card-element-error" role="alert"></div>                    
</div>

<style>
.StripeComponent{
    padding: 0.75rem;
    border-radius: 8px;
    border: 1px solid #AAB8C2;
    width: 100%;
}
</style>